// src/pages/PagarFacturas.js
import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Checkbox,
  Button,
  Divider,
} from '@mui/material';
import { api } from './api';

const PagarFacturas = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { facturas = [], seleccionInicial } = location.state || {};

  const [linkPago, setLinkPago] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
const user = JSON.parse(localStorage.getItem("user") || "{}");

  // Función para calcular importe según vencimientos
  const calcularImporte = (fac) => {
    const hoy = new Date();
    const vto1 = fac.vto1 ? new Date(fac.vto1) : null;
    const vto2 = fac.vto2 ? new Date(fac.vto2) : null;
    let importe = fac.imp1 ?? 0;

    if (vto1 && hoy > vto1 && fac.imp2 && fac.imp2 > 0) importe = fac.imp2;
    if (vto2 && hoy > vto2) {
      if (fac.imp3 && fac.imp3 > 0) importe = fac.imp3;
      else if (fac.imp2 && fac.imp2 > 0) importe = fac.imp2;
    }

    return importe;
  };

  // Inicializar seleccionadas
  const [seleccionadas, setSeleccionadas] = useState(
    seleccionInicial
      ? [{ compNro: seleccionInicial.compNro, imp: calcularImporte(seleccionInicial) }]
      : []
  );

  const toggleFactura = (fac) => {
    const importe = calcularImporte(fac);

    setSeleccionadas((prev) =>
      prev.some((f) => f.compNro === fac.compNro)
        ? prev.filter((f) => f.compNro !== fac.compNro)
        : [...prev, { compNro: fac.compNro, imp: importe }]
    );
  };

  const handleConfirmarPago = async () => {
    if (seleccionadas.length === 0) {
      alert("Seleccioná al menos una factura");
      return;
    }

    setLoading(true);
    setError("");

    try {
        const facturasPayload = seleccionadas.map(f => {
            const original = facturas.find(fac => fac.compNro === f.compNro);
            return {
                imp: f.imp,
                compTpo: original?.compTpo || "",
                compLet: original?.compLet || "",
                compNro: original?.compNro || 0,
                cliCod: original?.cliCod || 0,
                sumNro: original?.sumNro || 0,
            };
        });
    const payload = {
        userId: user.Id, 
        facturas: facturasPayload
    };


    const res = await api.pvs.generarLinkDePago(payload)

      const { data } = res.link;
      const internalId = data.id || data.uuid;
      const link = data.link;
      const amount = seleccionadas.reduce((a, f) => a + f.imp, 0);

      console.log("InternalId:", internalId);
      console.log("Monto total:", amount);

      setLinkPago(link);
      window.open(link, "_blank");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const total = seleccionadas.reduce((sum, f) => sum + f.imp, 0);

  return (
    <Box p={2} maxWidth={800} mx="auto">
    <Typography
      variant="h6"
      gutterBottom
      sx={{ fontWeight: 'bold' }}
    >
      Selecciona las facturas a pagar
    </Typography>

      <List>
        {facturas.map((fac) => {
          const importe = calcularImporte(fac);

          return (
            <ListItem
              key={fac.compNro}
              button
              onClick={() => toggleFactura(fac)}
              sx={{ border: '1px solid #ddd', borderRadius: 2, mb: 1, bgcolor:'white' }}
              secondaryAction={
                <Typography variant="body1" sx={{ color: 'error.main', fontWeight: 'bold' }}>
                  ${importe.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
                </Typography>
              }
            >
              <ListItemIcon>
                <Checkbox checked={seleccionadas.some(f => f.compNro === fac.compNro)} />
              </ListItemIcon>
              <ListItemText
                secondary={
                  <>
                    <Typography variant="body2">
                      <span style={{ fontWeight: 600 }}>{fac.cliApe}</span>{' '}
                      <span style={{ color: '#888' }}>Socio {fac.cliCod}</span>{' '}
                      <span style={{ color: '#888' }}>Sum {fac.sumNro}</span>
                    </Typography>
                    <Typography variant="body2" sx={{ color: '#aaa' }}>
                      {fac.inmDom}
                    </Typography>
                    <Typography variant="body2">
                      {`${fac.compTpo} ${fac.compLet}-${fac.compNro}`} - {fac.servicio}
                    </Typography>
                    <Typography variant="body2">
                      Vence: {fac.vto1 ? new Date(fac.vto1).toLocaleDateString('es-AR') : '-'}{' '}
                      {fac.vto2 ? `(2° vto: ${new Date(fac.vto2).toLocaleDateString('es-AR')})` : ''}
                    </Typography>
                  </>
                }
              />
            </ListItem>
          );
        })}
      </List>

      <Divider sx={{ my: 2 }} />
      <Box display="flex" justifyContent="space-between" mb={2}>
        <Typography variant="subtitle1">Total a pagar ({seleccionadas.length} facturas)</Typography>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold', color: 'error.main' }}>
          ${total.toLocaleString('es-AR', { minimumFractionDigits: 2 })}
        </Typography>
      </Box>

      <Button
        variant="contained"
        color="success"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleConfirmarPago}
        disabled={loading}
      >
        Ir a Pagar
      </Button>

      <Button
        variant="outlined"
        fullWidth
        sx={{ mt: 1 }}
        onClick={() => navigate(-1)}
      >
        Cancelar
      </Button>

      {error && (
        <Typography color="error" mt={2}>
          {error}
        </Typography>
      )}
    </Box>
  );
};

export default PagarFacturas;
